'use strict';

/**
 * T315 Module Lock — LD-2 golden padlock state map.
 *
 * Three legible states distinguished by BOTH shackle shape AND color
 * (never color-as-sole-signal — a11y / colour-blind / screenshots).
 *
 *   NO_LOCK   — open/unlatched outline, muted gold,  "Add Module Lock"
 *   UNLOCKED  — open padlock,          bright gold,  "Lock now"
 *   LOCKED    — closed/latched,        bright gold,  "Unlock module"
 *
 * Theme-aware: light theme uses a darker gold so contrast stays ≥3:1.
 */

const { ML_STRINGS } = require('./policy');

// Bright gold for dark UI; darker gold for light UI (contrast).
const GOLD_DARK_THEME = '#f5c518';   // bright gold on dark bg
const GOLD_LIGHT_THEME = '#b8860b';  // dark goldenrod on light bg (≥3:1)
const GOLD_MUTED_DARK = '#c9a227';   // muted gold (no-lock) on dark
const GOLD_MUTED_LIGHT = '#9c7a1a';  // muted gold on light

const STATES = Object.freeze({
  NO_LOCK: {
    shackle: 'open',
    latched: false,
    ariaLabel: ML_STRINGS.ADD_LOCK,
    tooltip: ML_STRINGS.ADD_LOCK,
    muted: true,
  },
  UNLOCKED: {
    shackle: 'open',
    latched: false,
    ariaLabel: ML_STRINGS.LOCK_NOW,
    tooltip: ML_STRINGS.LOCK_NOW,
    muted: false,
  },
  LOCKED: {
    shackle: 'closed',
    latched: true,
    ariaLabel: ML_STRINGS.UNLOCK,
    tooltip: ML_STRINGS.UNLOCK,
    muted: false,
  },
});

function iconState(state, opts) {
  const def = STATES[state];
  if (!def) throw new Error('Unknown Module Lock icon state: ' + state);
  const theme = (opts && opts.theme) === 'light' ? 'light' : 'dark';
  let color;
  if (def.muted) {
    color = theme === 'light' ? GOLD_MUTED_LIGHT : GOLD_MUTED_DARK;
  } else {
    color = theme === 'light' ? GOLD_LIGHT_THEME : GOLD_DARK_THEME;
  }
  return {
    state,
    shackle: def.shackle,
    latched: def.latched,
    color,
    ariaLabel: def.ariaLabel,
    tooltip: def.tooltip,
  };
}

/**
 * SVG path for the shackle (the U-shaped top). The open variant lifts +
 * rotates the right leg; the closed variant seats both legs in the body.
 * Body rectangle is rendered separately by the caller.
 */
function shacklePath(shackle) {
  if (shackle === 'closed') {
    // both legs seated into the body
    return 'M7 10 V7 a5 5 0 0 1 10 0 V10';
  }
  // open — right leg lifted/rotated
  return 'M7 10 V7 a5 5 0 0 1 9.5 -1.5';
}

module.exports = {
  iconState,
  shacklePath,
  GOLD_DARK_THEME,
  GOLD_LIGHT_THEME,
  STATE_NAMES: Object.keys(STATES),
};
